import { IHallBooking } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	startDate: number
	endDate: number
	locationId: string
	contactId: string
	reason: string
	deposit: number
	paymentRemarks: string
}

export async function hallBookingAddApi(
	payload: RequestDataShape,
	token?: null | string,
) {
	const endpoint = "/hall/booking/add/v1"
	const requester = new ApiRequester<RequestDataShape, IHallBooking>(endpoint)
	return await requester.sendRequest(payload, token)
}
